import React from 'react';
import { useLogos } from '@/hooks/useLogos';
import ImageManager from '@/components/media/ImageManager';

export default function FormHeader() {
  const { updateCounter } = useLogos();
  const abielAvatar = "https://imgur.com/a/s0UaN17";

  return (
    <div className="text-center mb-4">
      <h1 className="text-xl font-bold text-black dark:text-gold tracking-wide mx-1 mb-3">
        Abiel
      </h1>
      <div className="flex justify-center mb-2">
        <div className="relative">
          <ImageManager
            src={abielAvatar}
            alt="Prayer Assistant Logo"
            type="avatar"
            className="h-24 w-24 rounded-full border-2 border-gold/30 shadow-lg"
            key={`form-header-logo-${updateCounter}`}
          />
        </div>
      </div>
      <p className="text-lg text-black/80 dark:text-gold/80 font-medium mb-1">
        @Abiel-prayer companion
      </p>
      <div className="space-y-1">
        <h2 className="text-lg font-bold text-black dark:text-gold tracking-wide">
          Let Abiel Pray with You
        </h2>
      </div>
    </div>
  );
}
